"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireWildcard(require("./_base"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Palette composition: colorName: the main color shade colorName_1 ->
 * colorName_4 : shades for the color 1 is the lightest, 4 the darkest 1 & 2 are
 * lighter shades 3 & 4 darker shades the base colorName shade would be in the
 * middle.
 *
 * The exception are the "dark" and "light" color neutrals for these 2 palettes
 * the base color falls at the end of the spectrum.
 *
 * It is recommended that dark text is used over shades 1 & 2
 * and light text over shades 3 & 4.
 */
var palette = {
  green: "#14AD7D",
  green_1: "#D0EFE5",
  // shade lightest
  green_2: "#72CEB1",
  // shade light
  green_3: "#09875F",
  // shade darker
  green_4: "#224E53",
  // shade darkest

  dark: "#222222",
  //   (HS)L 13.3 (darkest)
  dark_1: "#909090",
  // (HS)L 56.5
  dark_2: "#646464",
  // (HS)L 39.2
  dark_3: "#474747",
  // (HS)L 27.8
  dark_4: "#323232",
  // (HS)L 19.6

  light: "#FFFFFF",
  //   (HS)L 100 (lightest)
  light_1: "#FAFAFA",
  // (HS)L 98
  light_2: "#EDEDED",
  // (HS)L 92.9
  light_3: "#DEDEDE",
  // (HS)L 87.1
  light_4: "#BCBCBC",
  // (HS)L 73.7

  yellow: "#FFB12A",
  yellow_1: "#FFF7E9",
  // shade lightest
  yellow_2: "#FFD07F",
  // shade lighter
  yellow_3: "#F3A51E",
  // shade darker
  yellow_4: "#E3841C",
  // shade darkest

  red: "#F44B16",
  red_1: "#FDDBD0",
  // shade lightest
  red_2: "#F89373",
  // shade lighter
  red_3: "#D74010",
  // shade darker
  red_4: "#BF3206",
  // shade darkest

  blue: "#0065D4",
  blue_1: "#CCE0F6",
  // shade lightest
  blue_2: "#66A3E5",
  // shade lighter
  blue_3: "#055DBF",
  // shade darker
  blue_4: "#074891",
  // shade darkest

  purple: "#9155D2",
  purple_1: "#E9DDF6",
  // shade lightest
  purple_2: "#BD99E4",
  // shade lighter
  purple_3: "#7432BB",
  // shade darker
  purple_4: "#401C9C",
  // shade darkest

  teal: "#25B9DA",
  teal_1: "#D3F1F8",
  // shade lightest
  teal_2: "#7CD5E9",
  // shade lighter
  teal_3: "#26A2BD",
  // shade darker
  teal_4: "#113A57",
  // shade darkest

  magenta: "#E3427B",
  magenta_1: "#F9D9E5",
  // shade lightest
  magenta_2: "#EE8EB0",
  // shade lighter
  magenta_3: "#CD2460",
  // shade darker
  magenta_4: "#9F0B3F" // shade darkest
};

var colors = _objectSpread(_objectSpread({}, _base.baseColorTokens), {}, {
  primary: palette.green,
  primary_1: palette.green_1,
  // shade lightest
  primary_2: palette.green_2,
  // shade light
  primary_3: palette.green_3,
  // shade darker
  primary_4: palette.green_4,
  // shade darkest

  success: palette.green,
  success_1: palette.green_1,
  // shade lightest
  success_2: palette.green_2,
  // shade light
  success_3: palette.green_3,
  // shade darker
  success_4: palette.green_4,
  // shade darkest

  warning: palette.yellow,
  warning_1: palette.yellow_1,
  // shade lightest
  warning_2: palette.yellow_2,
  // shade light
  warning_3: palette.yellow_3,
  // shade darker
  warning_4: palette.yellow_4,
  // shade darkest

  error: palette.red,
  error_1: palette.red_1,
  // shade lightest
  error_2: palette.red_2,
  // shade light
  error_3: palette.red_3,
  // shade darker
  error_4: palette.red_4,
  // shade darkest

  /** UI tokens */
  // same as the base theme

  menuBackground: palette.green_4,
  menuSearchBackground: "#083b41",
  menuSearchText: palette.light,
  menuItem: palette.light,
  menuIconActive: palette.green,
  menuBackgroundActive: "#083b41",
  // Colors "palette" should be used directly ONLY IF THERE ISN'T A TOKEN that
  // is better suited for that color. NEVER USE palette colors in Smalt
  // components as they are theme specific and might be missing in some themes.
  palette: _objectSpread({}, palette)
});
var aodbTheme = _objectSpread(_objectSpread({}, _base["default"]), {}, {
  colors: colors
});
var _default = aodbTheme;
exports["default"] = _default;